import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { listDevUsers, deleteUser } from "../../actions/userAction";
import AdminMenu from "../../components/AdminMenu";
import RightDash from "../../components/RightDash";
import Message from "../../components/Message";
import "../../styles/dashboard.css";
import Signout from "../../components/Signout";

const AdminDevList = ({ resizeMenu, setResizeMenu }) => {
  const dispatch = useDispatch();

  const devUserList = useSelector((state) => state.devUserList);

  const { devUsers, loading, error } = devUserList;

  const userDelete = useSelector((state) => state.userDelete);

  const { success, loading: deleteLoading, error: deleteerror } = userDelete;

  useEffect(() => {
    dispatch(listDevUsers());
  }, [listDevUsers]);

  const deleteHandler = (id) => {
    dispatch(deleteUser(id));
  };

  return (
    <div className="dashboard">
      <AdminMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {deleteerror && <Message variant="danger">{deleteerror}</Message>}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <div className="right-wrapper">
            <div className="bio text-right">
              <button>
                <span>Hello Admin, Welcome!</span>
                <span className="px-50 py-25 rounded-circle ml-25 font-weight-bold font-sm">
                  A
                </span>
              </button>
            </div>
            <div className="main p-3">
              <div className="dashtable">
                <h4 className="font-medium mb-1 d-flex align-items-center">
                  Developers
                  {deleteLoading ? <div className="spinner-blue"></div> : ""}
                </h4>
                <div className="overflow-x">
                  <table>
                    <thead>
                      <tr className="text-uppercase tablehead">
                        <th>id</th>
                        <th>date</th>
                        <th>Name</th>
                        <th colSpan="2">Email</th>
                      </tr>
                    </thead>
                    {
                      <tbody>
                        {devUsers.length === 0 && <div>No developer yet</div>}
                        {devUsers.map((dev) => (
                          <tr key={dev._id}>
                            <td data-label="Id">
                              {dev._id.slice(14, dev._id.length)}
                            </td>
                            <td data-label="date">
                              {dev.createdAt.slice(0, 10)}
                            </td>
                            <td data-label="name">{dev.name}</td>
                            <td data-label="email">{dev.email}</td>
                            <td className="d-flex align-items-center">
                              <button onClick={() => deleteHandler(dev._id)}>
                                <i class="far fa-trash-alt"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    }
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default AdminDevList;
